import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const BackToDashboardIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 17 17" {...props}>
      <path
        d="M8.5 9.61133V16.6113L0.5 8.61133L8.5 0.611328V7.61133H16.5V9.61133H8.5Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default BackToDashboardIcon;
